module.exports = __webpack_public_path__ + "static/img/2.9a8d959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Responsabilidad-civil-danos-terceros/2.png
// module id = 8YOL
// module chunks = 0